import { Backdrop, Button, Container, Paper, MenuItem, Select, FormControl, InputLabel, Chip, Autocomplete, TextField } from "@mui/material";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import CustomHeader from "../../../core/components/common/custom-header.component";
import { useNavigate, useLocation } from "react-router-dom";
import CustomButton from "../../../core/components/ui/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from "dayjs";
import useVehicle from "../../VehiclePlugin/hooks/useVehicle";
import useDriver from "../../DriverPlugin/hooks/useDriver";
import GatePassService from "../services/api";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import moment from "moment";
import DateRangePickerComponent from "../../../core/components/common/custom-date-range-picker.component";
import { QRCodeSVG } from "qrcode.react";
import { useUser } from "../../UserPlugin/hooks/useUser";
import { useOrg } from "../../OrganizationPlugin/hooks/userOrg";
import { useSnackbar } from "notistack";


export default function GatepassCreatePage() {

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId || null;

    const view_org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const organizationId = view_org_uid || org_uid;

    const [vehicle_name, setVehicleName] = useState('');
    const [driver_name, setDriverName] = useState('');
    const [custom_valid_from, setCustomValidFrom] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [custom_valid_to, setCustomValidTo] = useState(moment().format('YYYY-MM-DD'));
    const [valid_from, setValidFrom] = useState(null);
    const [valid_to, setValidTo] = useState(null);
    const [gatepassErrors, setGatepassErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [success, setSuccess] = useState(false);
    const [usedRangePicker, setUsedRangePicker] = useState(false);
    const [qrData, setQrData] = useState('');
  

    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const location = useLocation();

    const { isFetchingVehicleList, vehicleListData, listVehicle } = useVehicle();
    const {getDriverList, driverList} = useDriver()

    const {listUserWithNoOrg, userList, filterUserList} = useUser();  


    // useEffect(() => {
    //   let parameter = {
    //     org_uid: organizationId
    //   }

    //  getDriverList(parameter)

    // },[organizationId])


    useEffect(() => {
        const parameters = {
          orgUID: organizationId,
        }
        listVehicle(parameters);
    }, [organizationId]);

    const vehicleList = vehicleListData ;

    useEffect(() => {
      if(!organizationId){
        listUserWithNoOrg();
      }else{
        let parameter = {
          org_uid: organizationId
        }

        getDriverList(parameter)
      }
    }, [organizationId]);

    const driverArray = (driverList && driverList.length > 0) ? driverList : userList;

useEffect(() => {
  console.log("filterUserList updated:", userList);
}, [userList]);


    console.log('get lissssssssssssssssssssssssssssssssst', driverArray)


    const handleBack = () => {
    
        navigate(-1);
    }

    const handleSubmit = async () => {
      const errors = {};
  
      if (!vehicle_name) errors.vehicle_name = "Vehicle name is required";
      if (!driver_name) errors.driver_name = "Driver name is required";
      if (!valid_from) errors.valid_from = "Valid From date is required";
      if (!valid_to) errors.valid_to = "Valid To date is required";
  
      setGatepassErrors(errors);
  
      if (Object.keys(errors).length > 0) {
          return;
      }
  
      setLoading(true);
  
      try {
          const payload = {
              vehicle_uid: vehicle_name,
              driver_uid: driver_name,
              valid_from: dayjs(valid_from).format("YYYY-MM-DD"),
              valid_to: dayjs(valid_to).format("YYYY-MM-DD"),
              org_uid: organizationId
          };

          if (usedRangePicker) {
            payload.custom_valid_from = custom_valid_from;
            payload.custom_valid_to = custom_valid_to;
          }
  
            const generatedVehicleData = await GatePassService.generateVehicleGatePass(payload);
            setQrData(generatedVehicleData.data.data.online_qr);

          setSuccess(true);
      } catch (error) {
          // handle error here
          const errorMessage = error?.response?.data?.error || error.message;
          enqueueSnackbar(errorMessage, {
              variant: "error",
              autoHideDuration: 4000
          });
          setLoading(false);
      }
  };
  

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading || success}>
              {success ? (
                 <Paper
                 elevation={4}
                 sx={{
                   p: 5,
                   textAlign: 'center',
                   borderRadius: 2,
                   minWidth: 360,
                   maxWidth: 480,
                   mx: 'auto',
                   backgroundColor: 'background.paper',
                   boxShadow: '0 12px 32px rgba(0,0,0,0.1)',
                 }}
               >
                 <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
           
                 <Typography variant="h5" color="success.main" fontWeight={600} gutterBottom>
                   Gatepass Created!
                 </Typography>
           
                 <Typography variant="body1" color="text.secondary" mb={3}>
                   The vehicle gatepass has been successfully saved and is now active. You can use the QR code below for scanning.
                 </Typography>
           
                 <Box
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   mb={4}
                   p={2}
                   borderRadius={2}
                   border="1px dashed"
                   borderColor="divider"
                   bgcolor="grey.50"
                 >
                   <QRCodeSVG value={qrData} size={160} />
                 </Box>
           
                 <Button
                   variant="contained"
                   color="primary"
                   size="large"
                   onClick={() => navigate(-1)}
                   sx={{
                     borderRadius: 2,
                     px: 5,
                     py: 1.2,
                     fontWeight: 500,
                   }}
                 >
                   Back to Gatepass List
                 </Button>
               </Paper>
                
              
              ) : (
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                  <CircularProgress color="inherit" value={progress} size={60} />
                  <Typography mt={2} sx={{ color: "#fff" }}>
                    Generating...
                  </Typography>
                </Box>
              )}
            </Backdrop>

            <CustomButton
                variant="text"
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Gate Pass List"
                customStyles={{ fontSize: 14, mt: 2 }}
                onClick={handleBack}
            />

            <Container maxWidth="md">
                <Paper elevation={0} sx={{ border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3 }}>
                    <Box sx={{ textAlign: "start", mb: 5 }}>
                        <CustomHeader headerText={"Create Gatepass"} />
                    </Box>

                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <FormControl variant="standard" fullWidth error={!!gatepassErrors.vehicle_name}>
                            <InputLabel shrink>Vehicle Plate Number</InputLabel>
                            <Select
                                value={vehicle_name}
                                onChange={(e) => setVehicleName(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="" ><Typography sx={{color:'gray'}}>Select plate number</Typography></MenuItem>
                                {vehicleListData?.content?.map((vehicle) => (
                                    <MenuItem value={vehicle?.vehicle_uid}>{vehicle?.plate_number}</MenuItem>
                                ))}
                                
                            </Select>
                            <Typography variant="caption" color="error">{gatepassErrors?.vehicle_name}</Typography>
                        </FormControl>

                        <Autocomplete
                            options={driverArray || []}
                            getOptionLabel={(option) => {
                              const user = option?.user_info?.[0] || option?.user_info;
                              return user ? `${user.firstname || ''} ${user.lastname || ''}`.trim() : '';
                            }}
                            isOptionEqualToValue={(option, value) => option?.profile_uid === value?.profile_uid}
                            value={
                              driverArray?.find((driver) => driver.profile_uid === driver_name) || null
                            }
                            onChange={(event, newValue) => {
                              setDriverName(newValue?.profile_uid || '');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Driver Name"
                                variant="standard"
                                fullWidth
                                error={Boolean(gatepassErrors?.driver_name)}
                                helperText={gatepassErrors?.driver_name || ''}
                              />
                            )}
                            renderOption={(props, option) => {
                              const user = option?.user_info?.[0] ? option?.user_info?.[0] : option?.user_info;
                              const fullName = user ? `${user.firstname || ''} ${user.lastname || ''}`.trim() : 'Unknown';

                              return (
                                <li {...props} key={option.profile_uid}>
                                  {fullName}
                                  {option?.profile_type && (
                                    <Chip
                                      label={option.profile_type}
                                      size="small"
                                      sx={{ ml: 2, bgcolor: '#0b99da', color: 'white' }}
                                    />
                                  )}
                                  {option?.role && (
                                    <Chip
                                      label={option.role}
                                      size="small"
                                      sx={{ ml: 2, bgcolor: 'green', color: 'white' }}
                                    />
                                  )}
                                </li>
                              );
                            }}
                          />



                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    label="Valid From"
                                    value={valid_from}
                                    onChange={setValidFrom}
                                    sx={{ width: '100%', overflow:'hidden' }}
                                    slotProps={{
                                        textField: {
                                            variant: 'standard',
                                            fullWidth: true,
                                            InputLabelProps: { shrink: true },
                                            error: !!gatepassErrors.valid_from,
                                            helperText: gatepassErrors.valid_from,
                                        },
                                    }}
                                />
                                <DatePicker
                                    label="Valid To"
                                    value={valid_to}
                                    onChange={setValidTo}
                                    sx={{ width: '100%', overflow:'hidden' }}
                                    slotProps={{
                                        textField: {
                                            variant: 'standard',
                                            fullWidth: true,
                                            InputLabelProps: { shrink: true },
                                            error: !!gatepassErrors.valid_to,
                                            helperText: gatepassErrors.valid_to,
                                        },
                                    }}
                                />

                              
                            </DemoContainer>
                        </LocalizationProvider>
                        
                          
                        <DateRangePickerComponent
                          initialStartDate={valid_from ? dayjs(valid_from).format('YYYY-MM-DD') : custom_valid_from}
                          initialEndDate={valid_to ? dayjs(valid_to).format('YYYY-MM-DD') : custom_valid_to}
                          disabled={!!valid_from || !!valid_to}
                          ranges={{
                            "Last 7 Days": [moment().subtract(6, "days"), moment()],
                            "This Month": [moment().startOf("month"), moment().endOf("month")],
                            "A Year": [moment(), moment().add(1, 'year')]
                          }}
                          onDateRangeChange={(start, end) => {
                            const formattedStart = moment(start).format('YYYY-MM-DD');
                            const formattedEnd = moment(end).format('YYYY-MM-DD');
                            setCustomValidFrom(formattedStart);
                            setCustomValidTo(formattedEnd);
                            setValidFrom(dayjs(start));
                            setValidTo(dayjs(end));
                            // setUsedRangePicker(true);
                          }}
                        />


                        <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
                            Create Gatepass
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </>
    );
}